<template>
  <div class="km__modules__color--buttons">
    <button class="km__button--back" type="button" name="back" @click="$emit('backbutton_clicked')"
            aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="$emit('closebutton_clicked')"
            aria-label="close"></button>
  </div>
</template>

<script lang="ts" setup>

import {useStore} from "vuex";
import {watch} from "vue";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const store = useStore();
const keyframes = new KeyFrameTargetValues(-150, 45, -130);
const animation = AnimationWaitingForTargetFactory.getUpDownAnimation(".km__modules__color--buttons");
const openStatusStore = useModuleColorOpenStateStore();
watch(() => openStatusStore.getButtonsState, newState => animation(keyframes.getTarget(newState)))

</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__color--buttons {
  background: config.$color-white;
  position: fixed;
  bottom: config.$cta-height;
  transform: translate(0, 40px);
  z-index: 8;
  width: 100%;
  height: 40px;
}
</style>
